import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import swal from '@sweetalert/with-react';


class Receipt extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showNumberWhatsapp: false,
            numberWhatsapp: null,
            showEmailAddress: false,
            emailAddress: null,
            btnLoading: false,
            showSMSNumber: false,
            phoneNumber: null,
        }
    }

    setWhatsappNumber() {
        const { showNumberWhatsapp } = this.state;
        this.setState({ showNumberWhatsapp: !showNumberWhatsapp, showEmailAddress: false, showSMSNumber: false })
    }

    sendWhatsapp() {
        const { numberWhatsapp } = this.state;
        if (this.props.receipt.result_code === 'ACCEPTED')
            window.open('https://api.whatsapp.com/send?phone=+55' + numberWhatsapp + '&text=%20*COMPROVANTE DE PAGAMENTO*%0A%0A *Status da transação*: ' + (this.props.receipt.result_code === 'ACCEPTED' ? 'TRANSAÇÃO APROVADA' : 'TRANSAÇÃO NEGADA') + '%0A*Autorização*: ' + this.props.receipt.authorization_code + '%0A*NSU*: ' + this.props.receipt.authorization_nsu);
        else
            window.open('https://api.whatsapp.com/send?phone=+55' + numberWhatsapp + '&text=%20*COMPROVANTE DE PAGAMENTO*%0A%0A *Status da transação*: ' + (this.props.receipt.result_code === 'ACCEPTED' ? 'TRANSAÇÃO APROVADA' : 'TRANSAÇÃO NEGADA'));
    }

    setEmail() {
        const { showEmailAddress } = this.state;
        this.setState({ showEmailAddress: !showEmailAddress, emailAddress: this.props.email, showNumberWhatsapp: false, showSMSNumber: false })
    }

    // sendEmail() {
    //     const { emailAddress } = this.state;
    //     this.setState({ btnLoading: true })

    //     fetch(process.env.REACT_APP_URL_AUTHENTICATION, {
    //         method: 'POST',
    //         body: JSON.stringify({
    //             "username": process.env,
    //             "password": process.env
    //         }),
    //         headers: { 'Content-Type': 'application/json' },
    //         credentials: "same-origin"
    //     }
    //     )
    //         .then(res => this.checkResponse(res))
    //         .then(res => {
    //             var j = res.json()
    //             return j
    //         })
    //         .then(msg => {
    //             fetch(process.env.REACT_APP_URL_API_MENSAGERIA + '/email/send', {
    //                 method: 'POST',
    //                 body: JSON.stringify({
    //                     "email_subject": "Comprovante de transação",
    //                     "client_email": emailAddress,
    //                     "template": "receipt.html",
    //                     "email_data": {
    //                         "client_name": this.props.customer_name,
    //                         "authorization_number": this.props.receipt.authorization_code ? this.props.receipt.authorization_code : " - ",
    //                         "nsu": this.props.receipt.authorization_nsu ? this.props.receipt.authorization_nsu : " - ",
    //                         "status_message": this.props.receipt.result_code === 'ACCEPTED' ? "TRANSAÇÃO APROVADA" : "TRANSAÇÃO NEGADA"
    //                     }
    //                 }),
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Authorization': msg.id_token
    //                 },
    //                 credentials: "same-origin"
    //             }
    //             )
    //                 .then(res => this.checkResponse(res))
    //                 .then(res => {
    //                     var j = res.json()
    //                     return j
    //                 })
    //                 .then(msg => {
    //                     console.log('MSG EMAIL', msg)
    //                     this.setState({ btnLoading: false })
    //                     swal("Sucesso!", "E-mail enviado com sucesso!", "success");
    //                 })
    //                 .catch(error => this.handleError(error))
    //         })
    //         .catch(error => this.handleError(error))


    // }

    setSMS() {
        const { showSMSNumber } = this.state;
        this.setState({ showSMSNumber: !showSMSNumber, phoneNumber: this.props.phone_number, showNumberWhatsapp: false, showEmailAddress: false })
    }

    // sendSMS() {
    //     const { phoneNumber } = this.state;
    //     this.setState({ btnLoading: true })

    //     fetch(process.env.REACT_APP_URL_AUTHENTICATION, {
    //         method: 'POST',
    //         body: JSON.stringify({
    //             "username": process.env,
    //             "password": process.env
    //         }),
    //         headers: { 'Content-Type': 'application/json' },
    //         credentials: "same-origin"
    //     }
    //     )
    //         .then(res => this.checkResponse(res))
    //         .then(res => {
    //             var j = res.json()
    //             return j
    //         })
    //         .then(msg => {
    //             fetch(process.env.REACT_APP_URL_API_MENSAGERIA + '/sms/send', {
    //                 method: 'POST',
    //                 body: JSON.stringify({
    //                     "phone_number": '55' + phoneNumber,
    //                     "msg": "Olá, "
    //                         + this.props.customer_name
    //                         + "\nEste é seu comprovante de pagamento: \nCód Autorização: "
    //                         + (this.props.receipt.authorization_code ? this.props.receipt.authorization_code + "\n" : " - \n")
    //                         + "NSU: " + (this.props.receipt.authorization_nsu ? this.props.receipt.authorization_nsu + "\n" : " - \n")
    //                         + "Status da transação: " + (this.props.receipt.result_code === 'ACCEPTED' ? "TRANSAÇÃO APROVADA \n" : "TRANSAÇÃO NEGADA \n")
    //                 }),
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Authorization': msg.id_token
    //                 },
    //                 credentials: "same-origin"
    //             }
    //             )
    //                 .then(res => this.checkResponse(res))
    //                 .then(res => {
    //                     var j = res.json()
    //                     return j
    //                 })
    //                 .then(msg => {
    //                     console.log('MSG EMAIL', msg)
    //                     this.setState({ btnLoading: false })
    //                     swal("Sucesso!", "SMS enviado com sucesso!", "success");
    //                 })
    //                 .catch(error => this.handleError(error))
    //         })
    //         .catch(error => this.handleError(error))


    // }

    checkResponse(response) {
        if (!response.ok) {
            throw new Error(response.statusText)
        }
        return response
    }

    handleError(error) {
        this.setState({ btnLoading: false })
        swal(error.message, "Ops! Houve um problema ao enviar a requisição.", "error");
    }


    handleInputChange = ({ target }) => {
        this.setState({ [target.name]: target.value });
    }

    render() {
        return (
            <>
                <Modal show={this.props.showReceipt} onHide={this.props.handleClose}>
                    {/* <Modal.Header closeButton>
                        <Modal.Title>Modal heading</Modal.Title>
                    </Modal.Header> */}
                    <Modal.Body>
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-5" style={{ fontWeight: 'bold' }}>
                                    Status da transação
                                </div>
                                <div className="col-sm-7">
                                    <span className={this.props.receipt.result_code === 'DENIED'
                                        ? "float-right text-danger"
                                        : this.props.receipt.result_code === 'BLOCKED'
                                            ? "float-right text-danger"
                                            : "float-right text-success"} >
                                        {
                                            this.props.receipt.result_code === 'DENIED'
                                                ? 'TRANSAÇÃO NÃO REALIZADA'
                                                : this.props.receipt.result_code === 'BLOCKED'
                                                ? 'TRANSAÇÃO NEGADA'
                                                : 'TRANSAÇÃO APROVADA'

                                        }
                                    </span>
                                </div>
                            </div>
                            {
                                this.props.receipt.result_code !== 'ACCEPTED' ? (
                                    <div className="row">
                                        <div className="col-sm" style={{ fontWeight: 'bold' }}>
                                            Motivo
                                        </div>
                                        <div className="col-sm">
                                            <span className="float-right text-danger" >
                                                {this.props.receipt.result_code === 'BLOCKED' ? ('Transação não autorizada') : (this.props.receipt.response_code + " - " + this.props.receipt.response_text)}
                                            </span>
                                        </div>
                                    </div>
                                ) : null
                            }

                            {this.props.receipt.authorization_number ? (
                                <div className="row">
                                    <div className="col-sm" style={{ fontWeight: 'bold' }}>
                                        Autorização
                                    </div>
                                    <div className="col-sm">
                                        <span className="float-right">{this.props.receipt.authorization_number}</span>
                                    </div>
                                </div>
                            ) : null}



                            {this.props.receipt.nsu ? (
                                <div className="row">
                                    <div className="col-sm" style={{ fontWeight: 'bold' }}>
                                        NSU
                                    </div>
                                    <div className="col-sm">
                                        <span className="float-right">{this.props.receipt.nsu}</span>
                                    </div>
                                </div>
                            ) : null}


                            {this.props.receipt.authorization_result ? (
                                <div className="row">
                                    <div className="col-sm" style={{ fontWeight: 'bold' }}>
                                        Código de resposta
                                    </div>
                                    <div className="col-sm">
                                        <span className="float-right">{this.props.receipt.authorization_result}</span>
                                    </div>
                                </div>
                            ) : null}

                        </div>
                        <div className="container mt-4">
                            <Button onClick={() => this.setWhatsappNumber()} variant="success">
                                <i className="fab fa-whatsapp"></i> Whatsapp
                            </Button>{" "}
                            {/* <Button variant="primary" onClick={() => this.setEmail()}>
                                <i className="fas fa-envelope-open-text"></i> Email
                            </Button>{" "}
                            <Button variant="info" onClick={() => this.setSMS()}>
                                <i className="fas fa-mobile-alt"></i> SMS
                            </Button> */}
                        </div>

                        {
                            this.state.showNumberWhatsapp ? (
                                <div className="container mt-4">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="form-group">
                                                <label htmlFor="whatsAppNumero">Nº Whatsapp</label>
                                                <MaskedInput
                                                    mask={['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                                    className={"form-control"}
                                                    placeholder="(11)999999999"
                                                    guide={false}
                                                    name="numberWhatsapp"
                                                    id="numberWhatsapp"
                                                    value={this.state.numberWhatsapp}
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <Button style={{ marginTop: 32 }} onClick={() => this.sendWhatsapp()} variant="success">
                                                <i className="fas fa-paper-plane"></i> Enviar
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            ) : null
                        }
                        {
                            // this.state.showEmailAddress ? (
                            //     <div className="container mt-4">
                            //         <div className="row">
                            //             <div className="col-md-8">
                            //                 <div className="form-group">
                            //                     <label htmlFor="whatsAppNumero">Email para envio</label>
                            //                     <input
                            //                         type="text"
                            //                         className={"form-control"}
                            //                         id="emailAddress"
                            //                         name="emailAddress"
                            //                         value={this.state.emailAddress}
                            //                         maxLength="150"
                            //                         required
                            //                         placeholder="Email para contato"
                            //                         onChange={this.handleInputChange}
                            //                     />
                            //                 </div>
                            //             </div>

                            //             <div className="col-md-4">
                            //                 <Button disabled={this.state.btnLoading} style={{ marginTop: 32 }} onClick={() => this.sendEmail()} variant="primary">
                            //                     <i className="fas fa-paper-plane"></i> Enviar
                            //                 </Button>
                            //             </div>
                            //         </div>
                            //     </div>

                            // ) : null
                        }
                        {
                            // this.state.showSMSNumber ? (
                            //     <div className="container mt-4">
                            //         <div className="row">
                            //             <div className="col-md-8">
                            //                 <div className="form-group">
                            //                     <label htmlFor="phoneNumber">Nº Telefone</label>
                            //                     <MaskedInput
                            //                         mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                            //                         className={"form-control"}
                            //                         placeholder="11999999999"
                            //                         guide={false}
                            //                         name="phoneNumber"
                            //                         id="phoneNumber"
                            //                         value={this.state.phoneNumber}
                            //                         onChange={this.handleInputChange}
                            //                         required
                            //                     />
                            //                 </div>
                            //             </div>

                            //             <div className="col-md-4">
                            //                 <Button disabled={this.state.btnLoading} style={{ marginTop: 32 }} onClick={() => this.sendSMS()} variant="info">
                            //                     <i className="fas fa-paper-plane"></i> Enviar
                            //                 </Button>
                            //             </div>
                            //         </div>

                            //     </div>
                            // ) : null
                        }

                    </Modal.Body>
                </Modal>
            </>
        )
    }
}

export default Receipt;
